import { CanvaSX, renderChildren } from '../canvasx';
import { defaultShapeProps } from '../shapes';
import { calculateDimensionsForProps, drawRect } from '../util';

const defaultRectProps = { ...defaultShapeProps };
export type RectProps = Partial<ShapeStruct>;
export const Rect: CanvaSXComponent<RectProps, typeof defaultRectProps> =
  function (props) {
    let { children, width, height } = props;
    const { ctx } = CanvaSX.context;

    if (typeof width !== 'number' || typeof height !== 'number') {
      const dimensions = calculateDimensionsForProps(props);
      if (typeof width !== 'number') {
        width = dimensions.width;
      }
      if (typeof height !== 'number') {
        height = dimensions.height;
      }
    }

    drawRect(ctx, { ...props, width, height }, () => renderChildren(children));

    return null;
  };

Rect.defaultProps = defaultRectProps;
